<template>
  <div class="page flex column">
    <app-header :title="title" class="flex0">
      <i slot="back"></i>
    </app-header>
    <v-scroll class="flex1 bg healthFile">
      <index-base-info :user="docObj" class="bg_white"></index-base-info>
      <div class="basic">
        <div>
          基本情况
        </div>
      </div>
      <div tag="div" @click="goIll(history.presentingComplaint)" class="illness border-1px">
        <div>
          所患疾病
          <div>
            <span
              v-show="flag">{{ history.presentingComplaint ? history.presentingComplaint.substring(0, 5) + '......' : '无' }}</span>
            <img src="../../../static/img/查看更多.png" alt="">
          </div>
        </div>
      </div>
      <div tag="div" @click="goPastHistory(history.pastHistory)" class="history border-1px">
        <div>
          既往史
          <div>
                <span v-show="flag">
                {{ history.pastHistory ? history.pastHistory.substring(0, 5) + '......' : '无' }}
                </span>
            <img src="../../../static/img/查看更多.png" alt="">
          </div>
        </div>
      </div>
      <div tag="div" @click="goFamilyHistory(history.familyHistory)" class="family border-1px">
        <div>
          家族史
          <div>
                <span v-show="flag">
                 {{ history.familyHistory ? history.familyHistory.substring(0, 5) + '......' : '无' }}
                </span>
            <img src="../../../static/img/查看更多.png" alt="">
          </div>
        </div>
      </div>
      <div tag="div" @click="goAllergyHistory(history.allergyHistory)" class="alergic border-1px">
        <div>
          过敏史
          <div>
                <span v-show="flag">
                  {{ history.allergyHistory ? history.allergyHistory.substring(0, 5) + '......' : '无' }}
                </span>
            <img src="../../../static/img/查看更多.png" alt="">
          </div>
        </div>
      </div>
      <div class="basic">
        <div>
          诊疗记录
        </div>
      </div>
      <div class="recordList border-1px bg_white" v-show="historyList">
        <div class="wrapList" v-for="item of historyList" @click="goDelete(item)">
          <p class="listTime number">{{ item.createTime | Todate }}</p>
          <p class="listContent">{{ item.medContent }}</p>
          <div class="recordImg">
            <div v-for="url of item.sysAttachmentList">
              <img :src="url.url" alt="" @load="getImg">
            </div>

          </div>
        </div>
      </div>
    </v-scroll>
    <router-link :to="{path:'/addRecord',
            query:{
            patId:patId}}">+添加诊疗记录
    </router-link>
    <router-view></router-view>
  </div>
</template>
<script type="text/ecmascript-6">
import header from '../../base/header'
import BScroll from 'better-scroll'
import api from '../../lib/api'
import {Todate} from '../../lib/filter'
import {avaErrorMixin} from "../../lib/mixin";
import VScroll from "../../plugins/v-scroll";
import IndexBaseInfo from "../../plugins/my/index-base-info";

export default {
  data() {
    return {
      title: '健康档案',
      rightTitle: '',
      token: localStorage.getItem('token'),
      docObj: {},
      history: {},
      historyList: [],
      patId: '',
      flag: false
    }
  },
  filters: {
    Todate
  },
  mounted() {

    api('nethos.pat.info.get', {}).then(res => {
      if (res.succ) {
        this.docObj = res.obj;
        this.getData();
        this.getHistory();
        this.patId = res.obj.patId
      } else {

      }
    })
  },
  methods: {
    goAllergyHistory(val) {
      this.$router.push({
        name: 'allergyHistory',
        params: {
          val: val,
          patId: this.patId
        }
      })
    },
    goFamilyHistory(val) {
      this.$router.push({
        name: 'familyHistory',
        params: {
          val: val,
          patId: this.patId
        }
      })
    },
    goIll(val) {
      this.$router.push({
        name: 'ill',
        params: {
          val: val,
          patId: this.patId
        }
      })
    },
    goPastHistory(val) {
      this.$router.push({
        name: 'pastHistory',
        params: {
          val: val,
          patId: this.patId
        }
      })
    },
    goDelete(value) {
      this.$router.push({
        name: 'deleteRecord',
        params: {
          obj: value
        }
      })
    },
    getData() {
      api('nethos.pat.medicalinfo.details', {
        patId: this.docObj.patId,
      }).then(res => {
        if (res.succ) {
          console.log(res, 9999);
          if (res.obj) {
            console.log(this.flag)
            this.flag = true;
            this.history = res.obj;
          }

        } else {
          alert(res.msg)
        }
      })
    },
    getHistory() {
      api('nethos.pat.medicalhistroy.list', {
        "token": localStorage.getItem('token'),
        patId: this.docObj.patId,
      }).then(res => {
        if (res.succ) {
          console.log(res, 88888);
          this.historyList = res.list
        } else {
          alert(res.msg)
        }
      })
    },
    getImg() {
      console.log(212121);
      this._initFileScroll()
    },
  },
  components: {
    IndexBaseInfo,
    VScroll,
    'VHeader': header
  },
  mixins: [avaErrorMixin]
}
</script>
<style scoped lang="scss">
@import '../../common/public.scss';

.healthFile {

  .basic, .illness, .history, .family, .alergic, .record {
    width: 100%;
    height: 90rem/$rem;
    background-color: white;
    /*border-top: 1px solid rgb(205,205,205);*/
    > div {
      width: 690rem/$rem;
      height: 90rem/$rem;
      margin: 0 auto;
      display: flex;
      font-size: 32rem/$rem;
      font-family: PingFangSC;
      color: #333333;
      align-items: center;
      justify-content: space-between;

      > div {
        span {
          font-size: 32rem/$rem;
          font-family: PingFangSC;
          color: #666666;
          display: inline-block;
        }

        img {
          width: 7.5px;
        }
      }
    }
  }

  .basic, .record {
    background-color: rgb(245, 245, 245);
  }

  .basic {
    height: 80rem/$rem;

    > div {
      font-size: 28rem/$rem;
      font-family: PingFangSC;
      color: #666666;
    }
  }

  .recordList {
    width: 100%;
    /*border-bottom: 1px solid rgb(205,205,205);*/
    .wrapList {
      width: 690rem/$rem;
      margin: 0 auto;

      .listTime {
        font-size: 32rem $rem;
        color: #666666;
        font-family: PingFangSC;
        padding-top: 30rem/$rem;
        margin-bottom: 20rem/$rem;
      }

      .listContent {
        font-size: 28rem/$rem;
        font-family: PingFangSC;
        line-height: 20px;
        color: #666666;
      }

      .recordImg {
        width: 690rem/$rem;
        margin: 10px auto;
        display: flex;
        flex-wrap: wrap;

        > div {
          width: 25%;
          text-align: center;

          img {
            width: 140rem/$rem;
            height: 140rem/$rem;
          }
        }
      }
    }
  }
}

a {
  @extend %a;
  width: 100%;
  text-align: center;
}

.number {
  color: #3399FF !important;
}
</style>



// WEBPACK FOOTER //
// src/components/my/healthFile.vue